import { useState } from 'react';
import { Clipboard, Check, Share } from 'react-feather';
import { GetNavigatorShareData } from '../../util/share-helper';
import { Input } from './input';

interface ClipboardCopyProps {
    text: string;
    displayText?: string;
    className?: string;
}

export function ClipboardCopy({ className, text, displayText }: ClipboardCopyProps) {
    const [textCopied, setTextCopied] = useState<boolean>(false);
    const display = displayText || text;
    const canShare = navigator.share !== undefined && navigator.canShare;

    function onCopyClicked() {
        navigator.clipboard.writeText(text).then(() => {
            setTextCopied(true);
            setTimeout(() => setTextCopied(false), 2000);
        });
    }

    function onShareClicked() {
        const data = GetNavigatorShareData(text);
        navigator.share(data);
    }

    return (
        <div className={`${className} w-full`}>
            <div className="relative">
                <Input tabIndex={-1} type="text" className="text-center bg-muted font-mono" value={display} disabled readOnly />
                <div className="absolute end-2 top-1/2 -translate-y-1/2">
                    <button className="p-1 hover:bg-background text-foreground rounded hover:outline outline-secondary" onClick={onCopyClicked}>
                        {!textCopied && <Clipboard className="w-4 h-4" />}
                        {textCopied && <Check className="w-4 h-4" />}
                    </button>
                    {canShare &&
                        <button className="p-1 hover:bg-background text-foreground rounded hover:outline outline-secondary" onClick={onShareClicked}>
                            {<Share className="w-4 h-4" />}
                        </button>
                    }
                </div>
            </div>
        </div>
    );
}
